import React from 'react';
import { PiggyBank, Calendar } from 'lucide-react';

const EarlyRepaymentSection = ({ 
  formData, 
  handleInputChange, 
  errors, 
  earlyRepaymentPeriods 
}) => {
  return (
    <div className="mb-6 bg-purple-50 dark:bg-purple-900/20 p-4 rounded-lg border border-purple-200 dark:border-purple-800">
      <h3 className="text-base font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <PiggyBank className="w-5 h-5 mr-2 text-purple-500" />
        Досрочное погашение
      </h3>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* Сумма досрочного погашения */}
        <div>
          <label htmlFor="earlyRepaymentAmount" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            Сумма досрочного платежа
          </label>
          <input
            type="text"
            id="earlyRepaymentAmount"
            name="earlyRepaymentAmount"
            value={formData.earlyRepaymentAmount}
            onChange={handleInputChange}
            className={`form-input w-full ${errors.earlyRepaymentAmount ? 'input-error' : ''}`}
            placeholder="Введите сумму"
          />
          {errors.earlyRepaymentAmount && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.earlyRepaymentAmount}
            </p>
          )}
        </div>

        {/* Период досрочного погашения */}
        <div>
          <label htmlFor="earlyRepaymentPeriod" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            Периодичность
          </label>
          <select
            id="earlyRepaymentPeriod"
            name="earlyRepaymentPeriod"
            value={formData.earlyRepaymentPeriod}
            onChange={handleInputChange}
            className={`form-select w-full ${errors.earlyRepaymentPeriod ? 'input-error' : ''}`}
          >
            {Array.isArray(earlyRepaymentPeriods) ? (
              earlyRepaymentPeriods.map((period) => (
                <option key={period.id} value={period.id}>
                  {period.name}
                </option>
              ))
            ) : (
              <>
                <option value="monthly">Ежемесячно</option>
                <option value="quarterly">Ежеквартально</option>
                <option value="semi_annually">Раз в полгода</option>
                <option value="annually">Ежегодно</option>
                <option value="once">Разово</option>
              </>
            )}
          </select>
          {errors.earlyRepaymentPeriod && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.earlyRepaymentPeriod}
            </p>
          )}
        </div>

        {/* Месяц начала досрочного погашения */}
        <div>
          <label htmlFor="earlyRepaymentStartMonth" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
            <Calendar className="w-4 h-4 mr-2 text-purple-500" />
            Начать с месяца
          </label>
          <input
            type="text"
            id="earlyRepaymentStartMonth"
            name="earlyRepaymentStartMonth"
            value={formData.earlyRepaymentStartMonth}
            onChange={handleInputChange}
            className={`form-input w-full ${errors.earlyRepaymentStartMonth ? 'input-error' : ''}`}
            placeholder="Номер месяца"
          />
          {errors.earlyRepaymentStartMonth && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.earlyRepaymentStartMonth}
            </p>
          )}
        </div>

        {/* Тип досрочного погашения */}
        <div>
          <div className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
            Цель досрочного погашения
          </div>
          <div className="grid grid-cols-2 gap-2">
            <label className="inline-flex items-center">
              <input
                type="radio"
                name="earlyRepaymentType"
                value="reduction"
                checked={formData.earlyRepaymentType === 'reduction'}
                onChange={handleInputChange}
                className="form-radio"
              />
              <span className="ml-2 text-sm text-gray-700 dark:text-gray-300">
                Уменьшение срока
              </span>
            </label>
            <label className="inline-flex items-center">
              <input
                type="radio"
                name="earlyRepaymentType"
                value="payment"
                checked={formData.earlyRepaymentType === 'payment'}
                onChange={handleInputChange}
                className="form-radio"
              />
              <span className="ml-2 text-sm text-gray-700 dark:text-gray-300">
                Уменьшение платежа
              </span>
            </label>
          </div>
          {errors.earlyRepaymentType && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.earlyRepaymentType}
            </p>
          )}
        </div>
      </div>

      {/* Информационный блок о досрочном погашении */}
      <div className="mt-4 bg-purple-100 dark:bg-purple-900/30 p-3 rounded-lg border border-purple-200 dark:border-purple-800">
        <div className="flex items-start">
          <PiggyBank className="w-5 h-5 text-purple-600 dark:text-purple-400 mr-3 mt-1" />
          <div>
            <h4 className="text-sm font-medium text-purple-700 dark:text-purple-300 mb-1">
              Преимущества досрочного погашения
            </h4>
            <p className="text-xs text-purple-600 dark:text-purple-400">
              {formData.earlyRepaymentType === 'reduction' ? (
                "При уменьшении срока размер ежемесячного платежа остается прежним, но общая переплата по кредиту снижается значительно, так как вы быстрее погашаете основной долг."
              ) : (
                "При уменьшении платежа срок кредита остается прежним, но снижается ежемесячная финансовая нагрузка. Это удобно, если ваши доходы нестабильны."
              )}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EarlyRepaymentSection;